import {SmartComponent} from "smart-component-js";

class LinkParamsComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }

    appendSearchToLink(search) {
        const link = this.element.querySelector('a');
        if (!link) return;

        if (link.href.includes('?')) search = search.replace('?', '&');
        link.href += search;
    }

    init() {
        const search = window.location.search;
        if (!search) return;
        if (!search.includes('utm_')) return;
        this.appendSearchToLink(search);
    }
}

export default LinkParamsComponent;
